const DEFAULT_ROM_GATEWAY_BASE = 'https://retrofun-rom-gateway.planetarium.workers.dev';

/**
 * Configured in Vercel as REACT_APP_ROM_GATEWAY_BASE. It must point at the
 * public ROM gateway, without a trailing slash.
 */
export const ROM_GATEWAY_BASE =
  process.env.REACT_APP_ROM_GATEWAY_BASE ??
  DEFAULT_ROM_GATEWAY_BASE;

export const romUrl = (productCode: string) =>
  `${ROM_GATEWAY_BASE}/${encodeURIComponent(productCode)}`;
